module.exports = __webpack_public_path__ + "img/Bingo2_Info_Game_1.6dbc4dba.png";